import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isApplePayAvailible: null,
    typeFormToShow: null,
};

const configSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setApplePayAvailible(state, action) {
            state.isApplePayAvailible = action.payload;
        },
        setFormType(state, action) {
            state.typeFormToShow = action.payload;
        },
    },
});

export default configSlice.reducer;
export const { setApplePayAvailible, setFormType } = configSlice.actions;
